.rasa-chatbot-widget {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 99999999;
  --chat-message-max-width: 289px;
  --video-height: 170px;

  &__container {
    position: relative;
  }

  &__launcher {
    cursor: pointer;
    user-select: none;
    display: inline-flex;
    justify-content: center;
    width: 66px;
    height: 66px;
    align-items: center;
    background: var(--launcher-background-color);
    border-radius: 100px;
    color: var(--launcher-color);
  }

  &__launcher-image {
    width: 66px;
    height: 66px;
    border-radius: 50%;
  }
}

.messenger {
  position: absolute;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  bottom: 90px;
  right: 0;
  width: 375px;
  height: 85vh;
  max-height: 700px;
  background: var(--messenger-background-color);
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  z-index: 1000;
  opacity: 0;
  transform: scale(0);
  transform-origin: bottom right;
  transition: transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s, opacity 83ms ease-out 0s;
  &--open {
    opacity: 1;
    transform: scale(1);
  }

  &--fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    max-height: 100%;
    height: calc(100% - 100px);
    border-radius: 0;
  }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: var(--header-color);
      background: var(--header-background-color);
      padding: 16px 24px;
      font-family: 'OrtoRNIDS', 'Lato', sans-serif;
      font-size: 16px;
      font-weight: 700;
      line-height: 124%;
      letter-spacing: 0.6px;

    &__icon {
      cursor: pointer;
    }
  }

  &__content {
    padding: 16px 24px 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1 1 0%;
  }

  // Add bottom padding when feedback is enabled
  &--with-feedback &__content {
    padding-bottom: 80px;
  }

  &__content-wrapper {
    height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column-reverse;
  }
}

.rasa-icon {
  display: inline-flex;
}

.fullscreen {
  --chat-message-max-width: 560px;
  --video-width: 560px;
  --image-width: 560px;
}
